
import React, {Component} from "react";
import * as style from "./style.scss";
import {Avatar, Dropdown} from "antd";
import {FlatIcon} from "../Icon/index.js";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import signOut from '../../../utils/signOut.js';
import emptyAvatar from '../../../Assets/users/empty_avatar.jpg'


class CurrentUserDropDownMenu extends Component {

    handleLogOut = async () => {
        signOut();
    };

    items = [
        {
            label: (
                <div className={style.userInfo}>
                    <Avatar size={80} src={emptyAvatar} alt=""/>
                    <div className={style.content}>
                        <div className={style.name}>{this.props.user.userDemographics.name}</div>
                        <div className={style.username}>{this.props.user.userDemographics.email}</div>
                    </div>
                </div>
            ),
            key: "0"
        },
        {
            label: (
                <div onClick={ () => this.handleLogOut() }>
                    <FlatIcon icon={'exit'}/> Logout
                </div>
                
            ),
            key: "3"
        }

    ];

    render() {
        return (
            <Dropdown placement={'bottomRight'} className={style.currentUserDropDownMenu} menu={{items: this.items}}
                      trigger={['click']}>
                <a className="ant-dropdown-link" href="" onClick={(e) => e.preventDefault()}>
                    <Avatar src={'https://dummyimage.com/50&text=%20'} alt=""/>
                    <span className={style.dropDownUserFullName}>{this.props.user.userDemographics.name}</span>
                </a>
            </Dropdown>
        )
    }
}

CurrentUserDropDownMenu.propTypes = {
    user: PropTypes.object.isRequired
  };

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(
 mapStateToProps
)(CurrentUserDropDownMenu);
